/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { useState } from 'react';
import { defaultBrand } from '../constants/defaultBrand';
import { BrandContext } from '../contexts/BrandContext';

const BrandProvider = props => {
  const [brand, setBrand] = useState(defaultBrand);
  const [logo, setLogo] = useState('');

  return (
    <BrandContext.Provider value={{ brand, setBrand, logo, setLogo }}>
      {props.children}
    </BrandContext.Provider>
  );
};

export default BrandProvider;
